export function DoAutoZoom(backgroundPanel, targetPanel) {
  var done = false;
  var availableWidth = backgroundPanel.GetWidth(); //PlusBorder();
  var availableHeight = backgroundPanel.fHeight;
  var scaleFactor = 0.25;
  var si = 0.25;
  var nextScaleFactor = scaleFactor + si;

  var canvasWidth = targetPanel.fCanvasSizeX;
  var canvasHeight = targetPanel.fCanvasSizeY;

  while (!done) {
    var scaledCanvasWidth = Math.round(canvasWidth * nextScaleFactor);
    var scaledCanvasHeight = Math.round(canvasHeight * nextScaleFactor);

    if (scaledCanvasWidth > availableWidth || scaledCanvasHeight > availableHeight) done = true;
    else {
      scaleFactor = scaleFactor + si;
      nextScaleFactor = nextScaleFactor + si;
    }

    if (scaleFactor >= 1) done = true;
  }

  targetPanel.SetScaleFactor(scaleFactor);
}
